export const PERSISTENCE_KEYS = {
  propertiesFilters: 'pmc:filters:properties',
  ordersFilters: 'pmc:filters:orders',
  /** Page, page size and sort of each listing (DV-3455); see listingPaging.ts. */
  propertiesPaging: 'pmc:paging:properties',
  ordersPaging: 'pmc:paging:orders',
  globalOrdersFilters: 'pmc:filters:global-orders',
  /** Which global-orders view last wrote `globalOrdersFilters` (its bundle is shared by all four views). */
  globalOrdersFiltersView: 'pmc:filters:global-orders:view',
  addPropertyForm: 'pmc:form:add-property',
  addPropertyOrderForm: 'pmc:form:order-add-property'
} as const;

export function clearOrgScopedDrafts(): void {
  sessionStorage.removeItem(PERSISTENCE_KEYS.propertiesFilters);
  sessionStorage.removeItem(PERSISTENCE_KEYS.ordersFilters);
  sessionStorage.removeItem(PERSISTENCE_KEYS.propertiesPaging);
  sessionStorage.removeItem(PERSISTENCE_KEYS.ordersPaging);
  sessionStorage.removeItem(PERSISTENCE_KEYS.globalOrdersFilters);
  sessionStorage.removeItem(PERSISTENCE_KEYS.globalOrdersFiltersView);
  sessionStorage.removeItem(PERSISTENCE_KEYS.addPropertyForm);
  sessionStorage.removeItem(PERSISTENCE_KEYS.addPropertyOrderForm);
  // Legacy place-order session keys that are scoped to the active org/entity.
  sessionStorage.removeItem('orderTotalAmount');
  sessionStorage.removeItem('savingTotalAmount');
  sessionStorage.removeItem('subTotalAmount');
  sessionStorage.removeItem('propertyOccupancyStatus');
  sessionStorage.removeItem('confirmation_backup');
  sessionStorage.removeItem('confirmation_is_single');
}

export type PersistenceKey =
  (typeof PERSISTENCE_KEYS)[keyof typeof PERSISTENCE_KEYS];

export function clearPersistedForm(key: PersistenceKey): void {
  sessionStorage.removeItem(key);
}

export function safeMergeWithDefaults<T extends object>(
  stored: unknown,
  defaults: T
): T {
  if (stored === null || stored === undefined) return defaults;
  if (typeof stored !== 'object' || Array.isArray(stored)) return defaults;

  const merged = { ...defaults } as T;
  for (const key of Object.keys(defaults) as Array<keyof T>) {
    const value = (stored as Record<string, unknown>)[key as string];
    if (value !== undefined) {
      merged[key] = value as T[keyof T];
    }
  }
  return merged;
}
